import React from 'react'
import type { RadioChangeEvent } from 'antd'
import { Radio, RadioGroupProps, Space } from 'antd'

interface CustomRadioGroupProps extends RadioGroupProps {
  defaultValue: string,
  // eslint-disable-next-line no-unused-vars
  handleChange?: (value: string) => void,
  isVertical?: boolean
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = (props) => {
  const { defaultValue, children, handleChange = null, isVertical = false, ...restProps } = props

  const onChange = (e: RadioChangeEvent) => {
    if (handleChange) {
      handleChange(e.target.value)
    }
  }

  return (
    <Radio.Group
      onChange={onChange}
      value={defaultValue}
      {...restProps}
    >
      {isVertical ? (
        <Space direction='vertical'>
          {children}
        </Space>
      ) : <>{children}</>}
    </Radio.Group>
  )
}

export default CustomRadioGroup
